export default __webpack_public_path__ + "bb403c86607f103778880b04a59f1a9b.png";